export default function region() {
    return {
        regState(status) {
            return status ? 'Active' : 'Inactive';
        },
        toggleStatus($event, id) {
            axios.get(`/api/regions/${id}/toggle`).then(response => {
                $event.toElement.innerHTML = this.regState(response.data.data.region.status);
            }, error => { })
        },
    }
}
